module.exports = __webpack_public_path__ + "static/NaamanFrenkelCV-a2f5ceb6c55d1d843074e9bc41857776.pdf";